'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = require('prop-types');

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = require('./utils/track');

var _track3 = _interopRequireDefault(_track2);

var _events = require('./events');

var _traits = require('./traits');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_HORSE_BETTING, _propTypes3.default.number.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_HORSE_NEWS, _propTypes3.default.number.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_COMPETITIONS, _propTypes3.default.number.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BLOODSTOCK, _propTypes3.default.number.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_SPORT_BETTING, _propTypes3.default.number.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_OVER_EIGHTEEN, _propTypes3.default.number.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_R4R, _propTypes3.default.number.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_DAYLY_UPDATES, _propTypes3.default.number.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_THIRD_PARTY, _propTypes3.default.number.isRequired), _propTypes);

function trackPreferencesUpdate() {
    var _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_PREFERENCE_UPDATE + ' event');
    return (0, _track3.default)(_events.EVENT_PREFERENCE_UPDATE, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_HORSE_BETTING, traits[_traits.TRAIT_HORSE_BETTING]), (0, _defineProperty3.default)(_track, _traits.TRAIT_HORSE_NEWS, traits[_traits.TRAIT_HORSE_NEWS]), (0, _defineProperty3.default)(_track, _traits.TRAIT_COMPETITIONS, traits[_traits.TRAIT_COMPETITIONS]), (0, _defineProperty3.default)(_track, _traits.TRAIT_BLOODSTOCK, traits[_traits.TRAIT_BLOODSTOCK]), (0, _defineProperty3.default)(_track, _traits.TRAIT_SPORT_BETTING, traits[_traits.TRAIT_SPORT_BETTING]), (0, _defineProperty3.default)(_track, _traits.TRAIT_OVER_EIGHTEEN, traits[_traits.TRAIT_OVER_EIGHTEEN]), (0, _defineProperty3.default)(_track, _traits.TRAIT_R4R, traits[_traits.TRAIT_R4R]), (0, _defineProperty3.default)(_track, _traits.TRAIT_DAYLY_UPDATES, traits[_traits.TRAIT_DAYLY_UPDATES]), (0, _defineProperty3.default)(_track, _traits.TRAIT_THIRD_PARTY, traits[_traits.TRAIT_THIRD_PARTY]), _track));
}

exports.default = trackPreferencesUpdate;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/trackPreferencesUpdate.js
// module id = 1390
// module chunks = 1